import { App } from '@grafikr/components';

import './css/app.css';
import 'vendor/lazysizes';

import components from 'framework/components';
import state from 'framework/state';

const url = new URL(window.location.href);

if (url.searchParams.has('force-refresh')) {
  url.searchParams.delete('force-refresh');
  window.location.href = url.toString();
}

const app = new App();

components(app);
state(app);
app.mount();

document.addEventListener('shopify:section:load', ({ detail }) => {
  const section = document.getElementById(`shopify-section-${detail.sectionId}`);

  if (section) {
    app.mount(section);
  }
});
